import { isPlainObject } from 'lodash';

import { useMutation } from '@tanstack/react-query';

import * as Api from 'contracts/api';
import { RequestAgent } from 'modules/request-agent';
import { useNotify } from 'pages/components/SnackBarProvider';
import { UseExposedMutationOptions } from 'queries/types';
import { throwResponseError } from 'queries/utils';

export function useCollectionArchiveImperative(
    options?: UseExposedMutationOptions<Api.V4.Archive.Collection.Response, Error, Api.V4.Archive.Collection.Payload>
) {
    const notify = useNotify();
    return useMutation<Api.V4.Archive.Collection.Response, Error, Api.V4.Archive.Collection.Payload>({
        ...options,
        mutationFn: async (payload) => {
            try {
                const response = await new RequestAgent().public.get(Api.V4.Archive.Collection.Endpoint(), {
                    search: payload
                });

                if (isPlainObject(response)) {
                    throw throwResponseError(response);
                }

                const blob = await response.blob();
                const fileName =
                    response.headers
                        .get('content-disposition')
                        ?.match(/filename=(.*)/i)
                        ?.at(1) ?? `${payload.type}.collection`;

                return new File([blob], fileName, { type: blob.type });
            } catch (error) {
                notify.openNotification({ level: 'error', message: error.message });
                throw error;
            }
        }
    });
}
